import { render, staticRenderFns } from "./CRMSelect.vue?vue&type=template&id=abc276aa&scoped=true"
import script from "./CRMSelect.vue?vue&type=script&lang=js"
export * from "./CRMSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc276aa",
  null
  
)

export default component.exports